export default __webpack_public_path__ + "static/media/craon3.d20d4e53.jpg";